<template>
	<div>
		<h2 class="text-subtitle">Update Personal Info</h2>

		<ux-form ref="form">
			<div class="row">
				<div class="col-md-6">
					<ux-text-field
						label="First Name"
						:rules="rules.first_name"
						v-model="profile.first_name"
					/>
				</div>

				<div class="col-md-6">
					<ux-text-field
						label="Last Name"
						:rules="rules.last_name"
						v-model="profile.last_name"
					/>
				</div>

				<div class="col-xs-12">
					<ux-text-field
						label="Company Name"
						v-model="profile.company_name"
					/>
				</div>

				<div class="col-xs-12">
					<ux-text-field
						label="Email"
						:rules="rules.email"
						v-model="profile.email"
					/>
				</div>

				<div class="col-md-6">
					<ux-text-field
						label="Phone Number"
						:rules="rules.phone1"
						v-model="profile.phone1"
					/>
				</div>

				<div class="col-md-6">
					<ux-text-field
						label="Alternate Phone"
						v-model="profile.phone2"
					/>
				</div>
			</div>

			<ul class="ux-btn-list is-horz-end">
				<li><ux-btn color="outline-primary" :loading="saving" @click="save">Update Info</ux-btn></li>
			</ul>
		</ux-form>
	</div>
</template>

<script>
import { mapState } from 'vuex';

import api from 'frontend/api';
import validate from 'common/validators';
import alerts from 'common/alerts';

export default {
	data()
	{
		return {
			saving: false,
			profile: {},

			rules: {
				first_name: [ v => !!v || 'Please enter your first name' ],
				last_name: [ v => !!v || 'Please enter your last name' ],
				phone1: [ v => !!v || 'Please enter your phone number' ],
				email: [ 
					v => !!v || 'Please enter your email address',
					v => validate.email(v) || 'Invalid email address',
				],
			}
		}
	},

	computed: {
		...mapState({
			currentUser: state => state.shell.currentUser,
		})
	},

	methods: {
		async save()
		{
			if (!this.$refs.form.validate())
				return;

			this.saving = true;

			try
			{
				await api.post('/profile/update_info', { profile: this.profile });
				await alerts.show('Personal info updated successfully', 'Success', 'success');
				location.reload();
			}
			finally
			{
				this.loading = false;
			}
		}
	},

	created()
	{
		var fields = ['first_name', 'last_name', 'company_name', 'email', 'phone1', 'phone2'];
		var profile = {};

		for(var key of fields)
			profile[key] = this.currentUser[key];
		
		this.profile = profile;
	}
}
</script>